/**
 * Carga masiva de bookings con previsualización y validación (RF-B10 / RF-B11).
 *
 * Flujo: previsualizar -> resolver faltantes contra los maestros DOLE -> procesar.
 * A diferencia del endpoint anterior, procesar aplica SOLO las filas válidas y
 * deja las demás como pendientes.
 */
const base = () => (process.env.REACT_APP_API_URL || '') + '/carga-booking';
const baseMaestro = () => (process.env.REACT_APP_API_URL || '') + '/maestro-dole';

const auth = () => ({ 'Authorization': 'Bearer ' + (localStorage.getItem('jwt') || '').replaceAll('"', '') });
const authJson = () => ({ ...auth(), 'Content-Type': 'application/json' });

const manejar = async (resp) => {
    const data = await resp.json().catch(() => ({}));
    if (!resp.ok) {
        throw new Error(data.error || 'No se pudo completar la operación');
    }
    return data;
};

/** Parsea y valida el archivo SIN guardar nada. */
export const previsualizar = (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return fetch(`${base()}/previsualizar`, { method: 'POST', headers: auth(), body: fd }).then(manejar);
};

/** Aplica solo las filas válidas; las demás quedan pendientes. */
export const procesar = (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return fetch(`${base()}/procesar`, { method: 'POST', headers: auth(), body: fd }).then(manejar);
};

const baseDole = () => (process.env.REACT_APP_API_URL || '') + '/dole';

/** ATA BNP por archivo (BOOKING + ATA_BNP): valida sin guardar. */
export const previsualizarAtaBnp = (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return fetch(`${baseDole()}/ata-bnp/previsualizar`, { method: 'POST', headers: auth(), body: fd }).then(manejar);
};

/** ATA BNP por archivo: guarda/actualiza (upsert) cada booking. */
export const procesarAtaBnp = (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return fetch(`${baseDole()}/ata-bnp/procesar`, { method: 'POST', headers: auth(), body: fd }).then(manejar);
};

/** Historial de cargas (RF-B11). */
export const historialCargas = () =>
    fetch(`${base()}/historial`, { headers: auth() }).then(manejar);

/** Crea un valor faltante en un maestro DOLE, desde la grilla de preview. */
export const crearEnMaestro = (grupoCodigo, nombre, parametro) =>
    fetch(`${baseMaestro()}/grupo/${grupoCodigo}`, {
        method: 'POST', headers: authJson(), body: JSON.stringify({ nombre, parametro })
    }).then(manejar);

/** Grupo de maestro DOLE al que corresponde cada columna del archivo. */
export const GRUPO_POR_CAMPO = {
    'TIPO': 'DOL-0000-0003',            // Categoría de contenedor
    'PRIORIDAD': 'DOL-0000-0004',       // Prioridad de vacío
    'BARCOVIAJE': 'DOL-0000-0001'       // Barco (se crea la sigla)
};
